function buildTree(nodes) {
	const sortedNodes = nodes.sort(sortByLeft);
	const root = sortedNodes.splice(0, 1)[0];
	const tree = [];

	sortedNodes.forEach((node, index, array) => {
		const hasChildren = node.rgt - node.lft !== 1;

		const childrenNb = Math.trunc((node.rgt - node.lft) / 2);
		const children = array.splice(index + 1, childrenNb);

		tree.push({
			...node,
			children
		});

		// if (hasChildren) {
		// 	const childrenNb = Math.trunc((node.rgt - node.lft) / 2);
		// 	const children = array.splice(index + 1, childrenNb);
		//
		// 	tree.push({
		// 		...node,
		// 		children
		// 	});
		// 	return;
		// }
		//
		// tree.push(node);
	});

	const finalTree = { ...root, children: tree };

	return finalTree;
}

function sortByLeft(nodeA, nodeB) {
	return nodeA.lft - nodeB.lft;
}

export default buildTree;



// WEBPACK FOOTER //
// ./src/js/plan/lockings/tree.js